const validations = [
  {
    field: "vendorName",
    method: "isEmpty",
    validWhen: false,
    message: "Vendor / Contractor is a required field.",
  },
  {
    field: "contactName",
    method: "isEmpty",
    validWhen: false,
    message: "Contact Name is a required field.",
  },
  {
    field: "contactPhone",
    method: "isEmpty",
    validWhen: false,
    message: "Contact Phone Number is a required field.",
  },
  {
    field: "contactPhone",
    method: "matches",
    allowBlank: true,
    args: [/^(\(\d{3}\)\s\d{3}-\d{4})|(\d{10})$/],
    validWhen: true,
    message: "Contact Phone Number is not a valid phone number.",
  },
  {
    field: "contactPhone",
    method: "isLength",
    allowBlank: true,
    args: [10, 15],
    validWhen: true,
    message: "Contact Phone Number must be between 10 and 15 characters.",
  },
  {
    field: "contactEmail",
    method: "isEmpty",
    validWhen: false,
    message: "Contact Email is a required field.",
  },
  {
    field: "contactEmail",
    method: "isEmail",
    allowBlank: true,
    validWhen: true,
    message: "Contact Email Address must be a valid email address.",
  },
  {
    field: "startDate",
    method: "isEmpty",
    validWhen: false,
    message: "Start Date Date is required.",
  },
  {
    field: "startDate",
    allowBlank: true,
    method: "isISO8601",
    validWhen: true,
    message: "Start Date has to be a valid date.",
  },
  {
    field: "startDate",
    method: (startDate, state) => {
      if (!startDate || !state.expirationDate) return true;
      return new Date(startDate) <= new Date(state.expirationDate);
    },
    validWhen: true,
    message: "Date should prior to Expiration Date.",
  },
  {
    field: "expirationDate",
    method: (expirationDate, state) => {
      if (!expirationDate || !state.startDate) return true;
      return new Date(expirationDate) >= new Date(state.startDate);
    },
    validWhen: true,
    message: "Date cannot be prior to Start Date.",
  },
  {
    field: "expirationDate",
    method: "isEmpty",
    validWhen: false,
    message: "Expiration Date is required.",
  },
  {
    field: "expirationDate",
    allowBlank: true,
    method: "isISO8601",
    validWhen: true,
    message: "Expiration Date has to be a valid date.",
  },
  {
    field: "contractFinancialObligation",
    method: "isEmpty",
    validWhen: false,
    message: "Contract Financial Obligation is required.",
  },
  {
    field: "terminationNoticePeriodId",
    method: "isEmpty",
    validWhen: false,
    message: "Termination Notice Period is required.",
  },
  {
    field: "paymentTimePeriodId",
    method: "isEmpty",
    validWhen: false,
    message: "Payment Time Period is required.",
  },
  {
    field: "departmentId",
    method: "isEmpty",
    validWhen: false,
    message: "Department is required.",
  },
  {
    field: "signedById",
    method: "isEmpty",
    validWhen: false,
    message: "Signed By is required.",
  },
  {
    field: "notificationEmail",
    method: "isEmpty",
    validWhen: false,
    message: "Contract Notification Email is a required field.",
  },
];

export default validations;
